import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/schlix': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M350.5 157.7L296.3 111.6 369.7 72.6 448 116.8 350.5 157.7zM192 122.1L237.7 93.9 272.4 128.5 217 157.5 192 122.1zM126.9 128.7L158.8 106.6 176 135 139.3 157.5 126.9 128.7zM103.6 216.9L94.8 182.1 124.4 163.8 137.5 199.1 103.6 216.9zM82.4 133.2L106.3 115.1 115.2 139.1 88.5 157.4 82.4 133.2zM59 206.5L55.4 178.1 77.7 162.6 83.8 191.3 59 206.5zM28.4 223.1L49.2 210.3 52.5 243.7 29.6 255.7 28.4 223.1zM1.4 268L20.6 257.8 21 296 0 304.8 1.4 268zM60.5 327.3L32.2 335.6 30.6 288.8 55.7 278.1 60.5 327.3zM99 263.2L67.9 276.2 62.7 235.4 90.1 221 99 263.2zM123.2 377L81.6 382.9 73.5 319.4 108.7 308.6 123.2 377zM151.7 237.1L172.9 294.2 126.7 307.8 113 253.7 151.7 237.1zM237.4 467.6L166.5 464.3 142.2 368.5 197.4 359.9 237.4 467.6zM152.5 187.9L194.7 165.5 222.7 211.4 171.9 232.7 152.5 187.9zM193.5 282.8L254.8 264.1 307.6 350.7 227.8 362 193.5 282.8zM244.9 197.2L312.2 168.4 377.7 233.8 289.1 260 244.9 197.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/schlix.js
// module id = mS2s
// module chunks = 144